export default "__VITE_ASSET__BlbeXqut__"